import { defineMessages } from 'react-intl';

export const installmentCalulatorMessages = defineMessages({
  Headline: {
    id: 'ic-headline',
    defaultMessage: 'Ratenrechner',
  },
});
